import React from "react";
import Radio from "./Radio";
import { classnames } from "../../utils/text";

const Radios = ({ field, form, onChange, className, disabled, mode }) => {
  return (
    <div className={classnames("component-radio-wrap", className)}>
      {field.options &&
        field.options.list.map(({ label, value }, idx) => (
          <Radio
            key={idx}
            field={field}
            form={form}
            onChange={onChange}
            label={label}
            value={value}
            idx={idx}
            disabled={disabled || mode === 'view'}
          />
        ))}
    </div>
  );
};
export default Radios;
